// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetEmpty-modulebuttonEmpty__ix8ix";
export { _1 as "buttonEmpty" }
